// extracted by mini-css-extract-plugin
export default {"zoomModal":"x3-z"};